<script>
import CostService from "@/store/services/cost.service.js";
import TotalAmountsBase from "@/components/base_components/TotalAmountsBase.vue";

export default {
  name: "TotalAmountsCost",
  extends: TotalAmountsBase,
  data() {
    return {
      mutationName: 'filterStore/SET_UPDATE_FILTER_COSTS'
    }
  },
  methods: {
    getTotalAmounts(){
      if(Object.keys(this.filters).length !== 0){
        this.loading = true
        if(!this.filters.owner_company){
          this.filters.owner_company = window.company_id;
        }
        CostService.totalAmounts(this.filters).then((response) => {
          this.loading = false
          this.amountsList = [];
          this.amountsList.push({text: this.$gettext("NET"), amount: response.data['total_net'], class:'text-brand'});
          this.amountsList.push({text: this.$gettext("VAT"), amount: response.data['total_vat'], class:'text-blue'});
          if(window.company_country === 'ES'){
            this.amountsList.push({text: this.$gettext("IRPF"), amount: response.data['total_retention_tax'], class:'text-uninvoiced'});
          }
          this.amountsList.push({text: this.$gettext("TOTAL"), amount: response.data['total'], class:''});
        })
      }
    }
  }
};
</script>